import type { ReactNode } from "react";

export interface EmptyProps {
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
}

export function Empty({ icon, title, description, action }: EmptyProps) {
  return (
    <div className="rp-empty" role="status">
      {icon ? <div className="rp-empty__icon">{icon}</div> : null}
      <div className="rp-empty__title">{title}</div>
      {description ? <div className="rp-empty__desc">{description}</div> : null}
      {action ? <div className="rp-empty__action">{action}</div> : null}
    </div>
  );
}
